<template>
  <Bar
    :key="chartKey"
    :data="chartData"
    :options="computedOptions"
    :width=width
    :height=height
    id="area-screen-bar-chart"
  />
</template>

<script>
import { Bar } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(ChartDataLabels, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

//<area-screen-bar-chart ref="areaScreenBarChart" :data="areascreenbar_data_collection_merge" 
// :options="areascreenbar_option_setting" :width=380 :height=380 v-if="this.getStatAreaScreenBarChart()!= undefined"/>

export default {
  name: 'AreaScreenBarChart',
  components: { Bar },
  props: {
    data: { type: Object, required: true },
    options: {
      type: Object, required: true
    },
    width: { type: Number, default: 400 },
    height: { type: Number, default: 200 },
  },
  data() {
    return {
      chartData: {},
      computedOptions: {},
      chartKey: 0 // Add a key to force re-rendering
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.updateChartData();
      }
    },
    options: {
      deep: true,
      handler() {
        this.updateChartData();
      }
    }
  },
  created() {
    this.updateChartData();
  },
  methods: {
    updateChartData() {
      const data = this.data;

      // console.log("START: chartData");

      // Filter out datasets where all values are zero
      //const filteredDatasets = data.datasets.filter(dataset => !dataset.data.every(value => value === 0));

      const filteredDatasets = data.datasets;

      if (filteredDatasets.length === 0) {
        //console.log("All datasets are empty after filtering");
        this.chartData = {
          labels: [],
          datasets: [],
          originalData: []
        };
        this.chartKey += 1;
        return;
      }

      const originalData = filteredDatasets.map(dataset => ({
        label: dataset.label,
        backgroundColor: dataset.backgroundColor || 'rgba(0, 123, 255, 0.5)',
        data: dataset.data.slice()
      }));

      // console.log("originalData:" + JSON.stringify(originalData));

      const totalDataPerItem = [];
      for (let i = 0; i < filteredDatasets[0].data.length; i++) {
        let total = 0;
        for (let j = 0; j < filteredDatasets.length; j++) {
          total += filteredDatasets[j].data[i];
        }
        totalDataPerItem.push(total);
      }
      //console.log("totalDataPerItem:" + JSON.stringify(totalDataPerItem));

      // const filteredLabels = data.labels.filter((label, index) => {
      //   return !filteredDatasets.every(dataset => dataset.data[index] === 0);
      // });
      const filteredLabels = data.labels;

      const normalizedDatasets = filteredDatasets.map((dataset) => {
        const normalizedData = dataset.data.map((value, dataIndex) => {
          const total = totalDataPerItem[dataIndex];
          if (total) {
            return parseFloat(((value / total) * 100).toFixed(2));
          } else {
            return 0;
          }
        });

        return {
          label: dataset.label,
          backgroundColor: dataset.backgroundColor || 'rgba(0, 123, 255, 0.5)',
          data: normalizedData,
          originalData: dataset.data.slice()
        };
      });
      // console.log("normalizedDatasets:" + JSON.stringify(normalizedDatasets));

      this.chartData = {
        labels: filteredLabels,
        datasets: normalizedDatasets,
        originalData: originalData
      };

      this.computedOptions = {
        //responsive:false,
        maintainAspectRatio: false,
        responsive: false,  
        indexAxis: this.options.indexAxis,
        scales: {
          x: { 
            max: 100,
            stacked: true ,
            ticks:{
              callback:function(value){
                return value +'%'; // Append '%' to each label
              }
            }
          },
          y: { 
            stacked: true,
            position: 'right', // Move y-axis labels to the right
            ticks: {
              padding: 5, // Add padding to move labels to the right
              align: 'center' // Center-align the labels
            },
            grid: {
              display: false // Hide gridlines
            }
          }
        },
        plugins: {
          tooltip: { 
            callbacks: {
              label: (context) => {
                const datasetOriginalData = context.dataset.originalData || [];
                const originalValue = datasetOriginalData[context.dataIndex] !== undefined ? datasetOriginalData[context.dataIndex] : 0;
                const percentageValue = context.raw !== undefined ? context.raw.toFixed(2) : '0.00';
                return `${context.dataset.label}: ${originalValue} (${percentageValue}%)`;
              },
            },
          },
          datalabels: {
            display: true,
            color: 'white', // Change text color to white
            formatter: (value) => {
              const percentageValue = value.toFixed(2);
              return percentageValue !== '0.00' ? `${percentageValue}%` : ''; // Hide 0.00%
            },
            zIndex: 9999, // Set tooltip zIndex to a high valu
          },
          //legend: this.options.plugins.legend,
          legend: {
            display:true,
            labels: {
              boxWidth: 4, // Remove color box markers
              padding: 20, // Adjust padding between labels for better spacing
              font:{
                size:12
              }
            }

          },
          
          title: this.options.plugins.title,
        },

        elements: {
          bar: {
            // borderWidth: 1, // Add borders to the bars for better definition
            //borderWidth: { top: 0, right: 2, bottom: 0, left: 0 }, // 세로 테두리만 추가

            borderWidth: (context) => {
              // 마지막 막대의 borderWidth를 0으로 설정
              const dataLength = context.chart.data.labels.length;
              return context.dataIndex === dataLength - 1 ? 0 : 1; // 마지막 막대만 테두리 제거
            },
            borderColor: 'rgba(0, 0, 0, 0.1)', // 세로 테두리 색상
            borderSkipped: false // 모든 방향에 테두리 적용

          }
        }



      };

      // Force re-render by changing the key
      this.chartKey += 1;
    },
  },
};
</script>

<style scoped>
/* Add any additional styles if needed */
</style>
